/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    mapStateToProps as sourceMapStateToProps,
    MenuContainer as SourceMenuContainer
} from 'SourceComponent/Menu/Menu.container';
import { changeNavigationState } from 'Store/Navigation/Navigation.action';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import history from 'Util/History';
import MenuHelper, { fetchMenu } from 'Util/Menu';

import MenuComponent from './Menu.component';

/** @namespace Scandipwa/Component/Menu/Container/mapStateToProps */
// eslint-disable-next-line no-unused-vars
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    isLoading: state.ConfigReducer.isLoading
});

/** @namespace Scandipwa/Component/Menu/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    changeHeaderState: (state) => dispatch(changeNavigationState(TOP_NAVIGATION_TYPE, state))
});

/** @namespace Scandipwa/Component/Menu/Container */
export class MenuContainer extends SourceMenuContainer {
    static propTypes = {
        ...super.propTypes,
        changeHeaderState: PropTypes.func.isRequired
    };

    __construct(props) {
        super.__construct(props);

        const {
            stack: activeMenuItemsStack = []
        } = history.location.state || {};

        this.state = {
            activeMenuItemsStack,
            menu: {},
            timeOut: null
        };
    }

    containerFunctions = {
        ...this.containerFunctions,
        onBackClick: this.onBackClick.bind(this),
        onCategoryClick: this.onCategoryClick.bind(this)
    };

    onCategoryClick(activeSubcategory) {
        const { activeMenuItemsStack } = this.state;
        const { item_id } = activeSubcategory;

        if (item_id && !activeMenuItemsStack.includes(item_id)) {
            this.setState({ activeMenuItemsStack: [item_id] });
        } else {
            this.setState({ activeMenuItemsStack: [] });
        }
    }

    onBackClick() {
        this.setState(
            ({ activeMenuItemsStack }) => ({
                activeMenuItemsStack: activeMenuItemsStack.slice(1)
            })
        );
    }

    closeMenu() {
        const timeout = 500;

        setTimeout(() => {
            this.setState({ activeMenuItemsStack: [] });
        }, timeout);
    }

    _getMenu() {
        fetchMenu((menu) => this.setState({ menu: MenuHelper.reduce(menu) }));
    }

    onCategoryHover(activeSubcategory) {
        const { device } = this.props;
        if (device.isMobile) {
            return;
        }

        const { activeMenuItemsStack, timeOut } = this.state;
        const { item_id } = activeSubcategory;

        if (!activeMenuItemsStack.includes(item_id)) {
            const timeout = 500;

            this.setState({
                timeOut: setTimeout(() => {
                    this.setState({ activeMenuItemsStack: [item_id] });
                }, timeout)
            });
        }

        if (activeMenuItemsStack !== [] && activeMenuItemsStack !== [item_id]) {
            clearTimeout(timeOut);
        }
    }

    render() {
        return (
            <MenuComponent
              { ...this.props }
              { ...this.state }
              { ...this.containerFunctions }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuContainer);
